
import { ResultData } from "@nt-portal/common-sdk";
import { ControllerOptions, DataController } from "../../../../types";
import { BaseClientService } from "../../base-client.service";
import { TCMResponseField, TCMResponseFieldService } from "@nt-portal/tcm-sdk";
import { ValidateResult } from "@nt-portal/common-sdk";
import { createTCMScheduleSheet } from "../schedule/schedule-sheet.service";

export interface TCMResponseFieldOptions extends ControllerOptions<TCMResponseField> {
    sheetId: string;
}


export const initTCMResponseField = (inObj: Partial<TCMResponseField>): TCMResponseField => {
    let item: TCMResponseField = {
        excelHeading: inObj.excelHeading ?? "",
        name: inObj.name ?? "",


        sheet: inObj.sheet ?? createTCMScheduleSheet({}),
        order: 0,
        dataType: "string",
        displayType: "string",
        width: 0
    }
    return item;
}


export class ClientTCMResponseFieldService extends BaseClientService implements DataController<TCMResponseField> {

    private _service: TCMResponseFieldService;


    constructor() {
        super();
        this._service = new TCMResponseFieldService({
            apiService: this.apiService,
            url: this.settings.tcmServer
        });
    }

    public set params(params: any) {
        this._service.params = params;
    }

    public get params() {
        return this._service.params ?? {};
    }




    public async get(options: TCMResponseFieldOptions): Promise<ResultData<TCMResponseField>> {
        if (!this.params.scheduleId) {
            throw new Error("scheduleId is required for lookup");
        }
        if (!options.sheetId) {
            throw new Error("sheetId is required for lookup");
        }
        return await this._service.get(this.buildFetchParams(options), this.token, options.sheetId, options.filter);

    }
    public async getLookup(options: TCMResponseFieldOptions): Promise<ResultData<TCMResponseField>> {
        let fetchParams = this.buildLookupFetchParams(options);
        if (!options.sheetId) {
            throw new Error("sheetId is required for lookup");
        }
        let data = await this._service.get(fetchParams, this.token, options.sheetId, options.filter);
        return data;
    }

    public async getById(options: TCMResponseFieldOptions): Promise<TCMResponseField | null> {
        if (options.id) {
            let item = await this._service.getById(options.id, this.token);
            return item;
        }
        return null;
    }
    public async delete(options: TCMResponseFieldOptions): Promise<any> {
        if (options.id)
            await this._service.delete(options.id, this.token);
    }
    public async update(options: TCMResponseFieldOptions): Promise<TCMResponseField | TCMResponseField[] | null> {
        if (options.item && options.item.id)
            return await this._service.update(options.item.id, options.item, this.token)
        return null;
    }
    public async add(options: TCMResponseFieldOptions): Promise<TCMResponseField | TCMResponseField[] | null> {
        if (options.item)
            return await this._service.add(options.item, this.token)
        return null;
    }

    public async validateName(name: string, id?: string): Promise<ValidateResult> {
        return await this._service.validateName(name, this.token, id)
    }

    public async import(options: TCMResponseFieldOptions): Promise<any> {
        if (options.file)
            return await this._service.importExcel(options.file, this.token);
    }

    public async export(options: TCMResponseFieldOptions): Promise<any> {
        let fetchParams = this.buildLookupFetchParams(options);
        return await this._service.export(this.token, fetchParams, options.filter);
    }

    public async reset(options: TCMResponseFieldOptions): Promise<any> {
        if (!this.params.scheduleId) {
            throw new Error("scheduleId is required for lookup");
        }
        if (!options.sheetId) {
            throw new Error("sheetId is required for reset");
        }
        return await this._service.reset(this.token, options.sheetId);
    }

}

